/* eslint-disable no-use-before-define */
/* eslint-disable comma-spacing */
import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { translate } from '../../utils/util';

const InfiniteScrollUl = (props) => {
    const fetchMoreData = () => {
        const loading = document.getElementsByClassName('ui text loader')?.length > 0;
        if (!loading && (props.page > props.current.currentPage + 1)) {
            const current = props.current.currentPage + 1;
            props.current.setCurrentPage(current);
        }
    };

    return (
        <>
            {props.disableRow ? props.data :
                <InfiniteScroll
                    style={{ overflow: 'hidden !important', boxSizing: 'revert' }}
                    dataLength={props.data.length}
                    next={fetchMoreData}
                    hasMore={props.hasMore}
                >
                    {
                        props.data.map((item, index) => (
                            <div
                                key={`oi-${index += 1}`}
                                style={{ backgroundColor: 'white', boxShadow: '0 1px 5px 0 rgba(0,0,0,0.2)', padding: '4px' }}
                            >
                                {
                                    item
                                }
                            </div>
                        ))
                    }
                </InfiniteScroll>
            }
            {
                props.page !== undefined && props.data.length === 0 && (
                    <div className="container-fluid h-65" style={{ textAlign: 'center' }}>
                        {translate('general:no-registry')}
                    </div>)
            }
        </>
    );
};

export default InfiniteScrollUl;